const getCurrentElement = (elementsList) => {
  const item = elementsList[elementsList.length - 1];
  return item.element;
};

export default getCurrentElement;
